export default "__VITE_ASSET__Bif$F3XR__"